import { useTranslation } from "react-i18next"
import {
  BadgeStatus,
  EmptyCard,
  TableSkeleton,
  TableView
} from "../../../../../component/index.jsx"
import React from "react"
import { formatterRowComponent } from "../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { stringFormatting, convertDotToComma } from "../../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  DATE_TYPE_ENUM,
  INSPECTION_STATUS_ENUM,
  INSPECTION_STATUS_STRING,
  ROUTING_STATUS,
  UNIT_STRING
} from "../../../../../constants/StringConstant.js"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { useParams } from "react-router"
import { useHistory } from "react-router-dom"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { DetailSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"

export const BlockTable = ({ data, changePage, general, activeFilter, tab }) => {
  const { t } = useTranslation()
  const params = useParams()
  const history = useHistory()

  function checkBadgeColor(status) {
    switch (status) {
      case INSPECTION_STATUS_ENUM.PASS:
        return "success"
      case INSPECTION_STATUS_ENUM.NOT_PASS:
        return "danger"
      case INSPECTION_STATUS_ENUM.PARTIAL_PASS:
        return "warning"
    }
  }

  function uiCode(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.block_code)}
        </div>
        <div className={"d-flex"}>
          <div>{stringFormatting(e?.sub_district_name)}</div>
        </div>
      </>
    )
  }

  function uiMitra(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.mitra_name)}
        </div>
        <div>{stringFormatting(e?.mitra_phone)}</div>
      </div>
    )
  }

  function uiArea(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {convertDotToComma(e?.land_area_ha, UNIT_STRING.HA)}
        </div>
        <div>{stringFormatting(e?.total_area, "Lahan")}</div>
      </div>
    )
  }

  function uiVariety(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.variety)}
        </div>
        {tab === ROUTING_STATUS.BLOCK_STATUS_STRING.ACTIVE && (
          <div>{stringFormatting(e?.hst, "HST")}</div>
        )}
      </div>
    )
  }

  function uiLastInspection(e) {
    return (
      <div>
        {params?.tab === ROUTING_STATUS.BLOCK_STATUS_STRING.ACTIVE && (
          <>
            <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
              {stringFormatting(e?.last_activity)}
            </div>
            <div>
              {stringFormatting(
                timeStampToDate(e?.last_activity_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
              )}
            </div>
          </>
        )}
        {params?.tab === ROUTING_STATUS.BLOCK_STATUS_STRING.HISTORY && (
          <>
            <div>
              {stringFormatting(
                timeStampToDate(e?.block_inactive_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
              )}
            </div>
            <div>
              {stringFormatting(
                timeStampToDate(e?.block_inactive_date, DATE_TYPE_ENUM.ISO_TIME_STRAP)
              )}
            </div>
          </>
        )}
      </div>
    )
  }

  function uiInspectionStatus(e) {
    return (
      <div>
        {e?.status && (
          <BadgeStatus
            className={"w-130px"}
            variant={checkBadgeColor(e?.status)}
            status={INSPECTION_STATUS_STRING[e?.status]}
          />
        )}
      </div>
    )
  }

  const uiAction = (e) => {
    return (
      <div>
        <OverlayTrigger overlay={<Tooltip id="products-detail-tooltip">Detail</Tooltip>}>
          <div
            onClick={() => {
              history.push(RoutesConstants.AREA.DETAIL_BLOCK(params?.tab, e?.id))
            }}
            className={"btn btn-icon btn-list btn-hover-secondary btn-sm mx-3"}>
            <DetailSvgIcon />
          </div>
        </OverlayTrigger>
      </div>
    )
  }

  const columns = [
    {
      dataField: "code",
      text: t("table_header_block_name"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      headerStyle: () => {
        return { width: "15%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "mitra",
      text: t("table_header_mitra"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      }
    },
    {
      dataField: "totalAreaLand",
      text: t("table_header_area"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiArea
      },
      sortCaret: sortCaret
    },
    {
      dataField: "varietas",
      text: t("table_header_varietas"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiVariety
      }
    },
    params?.tab === ROUTING_STATUS.BLOCK_STATUS_STRING.ACTIVE && {
      dataField: "lastActivityDate",
      text: t("table_header_last_inspection"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiLastInspection
      },
      sortCaret: sortCaret
    },
    params?.tab === ROUTING_STATUS.BLOCK_STATUS_STRING.ACTIVE && {
      dataField: "status",
      text: t("table_header_inspection_status"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiInspectionStatus
      }
    },
    params?.tab === ROUTING_STATUS.BLOCK_STATUS_STRING.HISTORY && {
      dataField: "blockInactiveDate",
      text: t("table_header_nonactive_date"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiLastInspection
      },
      sortCaret: sortCaret
    },
    {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  return (
    <>
      <Card>
        <CardBody>
          {general.loading ? (
            <TableSkeleton column={6} row={10} />
          ) : data?.pageData?.length === 0 ? (
            <EmptyCard
              image={
                activeFilter
                  ? ILLUSTRATION_CONSTANTS.NOT_FOUND_DATA
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE_DATA
              }
              body={
                activeFilter
                  ? t("messages_response_response_not_found_data")
                  : t("messages_response_empty_state", { name: t("label_land_block") })
              }
              subtitle={activeFilter ? t("messages_response_sub_response_not_found_data") : ""}
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={data?.pageData ?? []}
            columnProperties={columns}
            loadingGetData={false}
            callbackAfterPageChange={changePage}
            currentPage={data?.page.currentPage}
            currentElement={data?.page.currentElement}
            totalCount={data?.page.totalCount}
            rowClasses={() => {
              return "cursor-pointer"
            }}
            keyField={"id"}
          />
        </CardBody>
      </Card>
    </>
  )
}